export default __webpack_public_path__ + "static/media/login-bg.e1e7538c.png";